import { MenuItem } from '@chakra-ui/react'
import { FC, useCallback, useMemo, useRef, useState } from 'react'
import CsvDownloader from 'react-csv-downloader'
import { GrDocumentCsv } from 'react-icons/gr'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import useReabTimeline from '@hook/parametrization/use-reab-timeline'
import useFilters from '@hook/shared/use-filters'
import useTools from '@hook/shared/use-tools'

import { parseParametrizatioReabCronogramaExport } from '@helper/grid/parametrization-curve'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ActionExcelReabCronograaExport: FC<ILayoutToolsExportAction> = ({
  headers,
  // eslint-disable-next-line unused-imports/no-unused-vars
  parser = parseParametrizatioReabCronogramaExport
}) => {
  const { isDisabled } = useTools()
  const { data } = useReabTimeline()
  const [, setDisabled] = useState(false)
  const [, updateDataNew] = useImmer<any[]>([])
  const { centers, distributionCenters } = useFilters()

  const csvDownload = useRef(null)
  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${header.group} - ${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getNameLoja = (lojaId: any) => {
    const lojdIdCenter = centers.find(x => x.value === Number(lojaId))
    if (lojdIdCenter === null) {
      return lojaId
    } else {
      return lojdIdCenter.label
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getNameDistribuition = (lojaId: any) => {
    const lojdIdCenter = distributionCenters.find(
      x => x.value === Number(lojaId)
    )
    if (lojdIdCenter === null) {
      return lojaId
    } else {
      return lojdIdCenter.label
    }
  }

  const rows = useMemo(() => {
    const parsedData = data
    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        if (column.id === 'cron-2') {
          item[column.id] = getNameDistribuition(row[column.id])
        } else if (column.id === 'cron-7') {
          item[column.id] = getNameLoja(row[column.id])
        } else {
          item[column.id] = row[column.id]
        }
      }

      body.push(item)
    }

    return body
  }, [columns, data, getNameDistribuition, getNameLoja])

  const dataFetch = useCallback(async () => {
    try {
      Swal.fire({
        title: 'Exportar dados!',
        html: 'Aguarde um momento<b></b>.',
        timerProgressBar: true,
        timer: 99999,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      updateDataNew(data)
      setDisabled(true)
      Swal.close()
      csvDownload.current.handleClick()
    } catch (error: any) {}
  }, [updateDataNew, data])
  return (
    <>
      {isDisabled ? (
        <>
          <MenuItem
            p="2px 12px"
            fontSize="sm"
            bgColor="white"
            _hover={{ bg: 'gray.400' }}
            isDisabled={isDisabled}
            onClick={dataFetch}
            icon={<GrDocumentCsv />}
          >
            <CsvDownloader
              filename={'Reab-Cronograma'}
              columns={columns}
              datas={rows}
              ref={csvDownload}
              text="Exportar para Tabela"
              separator=";"
              wrapColumnChar='"'
              bom={true}
            ></CsvDownloader>
          </MenuItem>
        </>
      ) : (
        <MenuItem
          p="2px 12px"
          fontSize="sm"
          bgColor="white"
          _hover={{ bg: 'gray.400' }}
          onClick={dataFetch}
          icon={<GrDocumentCsv />}
        >
          <CsvDownloader
            filename={'Reab-Cronograma'}
            columns={columns}
            datas={rows}
            ref={csvDownload}
            text="Exportar para Tabela"
            separator=";"
            wrapColumnChar='"'
            bom={true}
          ></CsvDownloader>
        </MenuItem>
      )}
    </>
  )
}

export default ActionExcelReabCronograaExport
